import React, { useMemo } from 'react';
import DatePicker, { DatePickerMode } from '@/components/DatePicker';
import { formatReportDateString, parseReportDateString } from './reportDateUtils';

interface ReportDateFieldProps {
  label: string;
  required?: boolean;
  value: string;
  onChange: (_value: string) => void;
  placeholder?: string;
  error?: string;
}

export const ReportDateField: React.FC<ReportDateFieldProps> = ({
  label,
  required = false,
  value,
  onChange,
  placeholder = 'Selecione a data',
  error,
}) => {
  const dateValue = useMemo(() => parseReportDateString(value), [value]);

  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-gray-700">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      <DatePicker
        value={dateValue}
        onChange={(date) => {
          if (date instanceof Date) {
            onChange(formatReportDateString(date));
            return;
          }
          onChange('');
        }}
        placeholder={placeholder}
        hasError={Boolean(error)}
        mode={DatePickerMode.Single}
        className="w-full"
      />
      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </div>
  );
};
